import type { ValidationFieldError } from "../../../services/vipOnboardingValidate";

export type MappedBranchErrors = {
  fieldErrors: Record<string, string>;
  rowErrors: Record<number, string>;
  sectionError: string | null;
};

const ROW_RE = /^(?:branches|facilities)\[(\d+)\]$/;
const FIELD_RE = /^(?:branches|facilities)\[(\d+)\]\.(.+)$/;

export function mapBranchErrors(
  errors: ValidationFieldError[],
  opts: { defaultBranchIndex?: number } = {},
): MappedBranchErrors {
  const fieldErrors: Record<string, string> = {};
  const rowErrors: Record<number, string> = {};
  let sectionError: string | null = null;

  for (const entry of errors) {
    const field = entry?.field;
    const message = entry?.message ?? "Invalid value";
    if (!field) continue;

    if (field === "branches" || field === "facilities") {
      sectionError = sectionError ? `${sectionError}; ${message}` : message;
      continue;
    }

    const rowMatch = ROW_RE.exec(field);
    if (rowMatch) {
      const idx = Number(rowMatch[1]);
      rowErrors[idx] = rowErrors[idx]
        ? `${rowErrors[idx]}; ${message}`
        : message;
      continue;
    }

    const fieldMatch = FIELD_RE.exec(field);
    if (fieldMatch) {
      const idx = fieldMatch[1];
      const subField = fieldMatch[2];
      fieldErrors[`branches.${idx}.${subField}`] = message;
      continue;
    }

    if (opts.defaultBranchIndex !== undefined) {
      fieldErrors[`branches.${opts.defaultBranchIndex}.${field}`] = message;
      continue;
    }
    fieldErrors[field] = message;
  }

  return { fieldErrors, rowErrors, sectionError };
}
